import React from 'react';
import Component from '@vfuk/core-link';
const Link = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default Link;
